import React from 'react';

import { generateRouteUrl } from '../../utils/core';
import { navigate } from '@reach/router';
import { tabDetailsObjects } from '../../config/admin';

const User = ({ tenantId }) => {

    const openAdminTab = () => {
        const route = generateRouteUrl({
            tabType: tabDetailsObjects.userSettings.slug,
            tenantId,
        });
        navigate(route);
    };

    return (
        <button 
            className="btn-icon user-settings-btn" 
            title="User Settings"
            onClick={() => openAdminTab()}
        >
            <span className="glyphicon glyphicon-user" />
        </button>
    );
};

export default User;
